export default __webpack_public_path__ + "static/media/green02.01d5f7ff.jpg";